export default __webpack_public_path__ + "static/media/Asset 3.f64457ae.png";